import React from 'react';
import SubscribeForm from 'components/Form/SubscribeForm';
import getButtonStyles from 'components/Core/Button/utils/getButtonStyles';
import HeaderModalForm from '../../HeaderModalForm';

import { RightMenuContainer, StyledButton, EmailCapture, EmailCaptureContainer } from './styles';

const RightMenu = ({ contextualCta }) => {
  const ctaButtonType = contextualCta?.color ? getButtonStyles(contextualCta.color) : 'normal';

  return (
    <RightMenuContainer className="desktop-right-menu">
      <div id="Original">
        {contextualCta?.__typename === 'ContentfulCallToAction' ? (
          contextualCta.useModalForm ? (
            <HeaderModalForm
              className={`website-header--button-cta header-cta--${ctaButtonType}`}
              buttonLabel={contextualCta.buttonLabel}
              inlineMarketingForm={contextualCta.modalForm}
              type={contextualCta.color}
            />
          ) : (
            <StyledButton
              to={contextualCta.url}
              type={contextualCta.color}
              className={`website-header--button-cta header-cta--${ctaButtonType}`}
              ctaPosition="navigation"
            >
              {contextualCta.buttonLabel}
            </StyledButton>
          )
        ) : (
          contextualCta?.__typename === 'ContentfulInlineMarketingForm' && (
            <EmailCaptureContainer showHeaderForm>
              <EmailCapture>
                <SubscribeForm
                  inlineMarketingForm={contextualCta}
                  formType="Email Capture"
                  dataPosition="Header"
                  shadow={false}
                  formClassNames="header-email-capture"
                  label="Get our weekly newsletter"
                />
              </EmailCapture>
            </EmailCaptureContainer>
          )
        )}
      </div>
    </RightMenuContainer>
  );
};

export default RightMenu;
